import React from "react";
import DomoFunnel from "../../../../../components/domoFunnel/domoFunnel";
import { shallowEqual, useSelector } from "react-redux";

const FunnelRetentionChart = () => {
  const { filters, offersDataNormalized } = useSelector((state) => {
    const { filters, offersDataNormalized } = state.funnelRetention;
    return { filters, offersDataNormalized };
  }, shallowEqual);
  return <DomoFunnel chartWidth={950} filters={filters} dataArray={offersDataNormalized} />;
};

export default FunnelRetentionChart;
